import FullWrapper from '../../layouts-components__common-cases/full-wrapper';
import './style.sass';
import Image from 'next/image';

const Marker = () => {
    return (
        <div className="rgs-marker">
            <FullWrapper isMargin={false}>
                <div className="rgs-markerWrapper">
                    <div className="rgs-markerTitle">
                        Основные функции Личного кабинета для продуктов КАСКО и&nbsp;ОСАГО
                    </div>

                    <div className="rgs-markerFrameItem">
                        <Image
                            src="/images/pic/rgs/r3.png"
                            alt="marker"
                            width={1312}
                            height={739}
                            className="rgs-markerImg"
                        />
                    </div>
                </div>
            </FullWrapper>
        </div>
    );
};

export default Marker;
